
export const languages = [
    {code: 'en',
      name: "English",
      dir :"ltr"
    },
    {
      code: 'ar',
      name :"العربية",
      dir :"rtl"
    }
  ] ;